<template>
    <el-aside width="100%" style="">
  <div style="height:100%;width:100%; display: flex;flex-direction: column;">

    <div style="height:50px;width:100%;background-color:#f8f8f8;">

      <div style="color:#970B0B;margin-top:15px;width:100%;height:50px" class="container_right">

        <div style="width:40%;display:flex">
          <div style="width:4px;background-color:#970B0B;height:40px"></div>
          <div style="margin:5px;color:#970B0B;">设备配置</div>
        </div>
        <div style="width:50%;justify-content: center;display: flex;">
          <div style="display: flex;margin-top:-11px">
            <el-input
                style="width:220px;"
                placeholder="请输入17位设备CID"
                v-model="cid"
                maxlength="17"
                type="text"
                clearable>
            </el-input>
          </div>
        </div>
        <div style="width:15%;color:#970B0B">
          <el-button @click="RightAddClick" size="mini" style="width:70%;background-color:#970B0B;color:#fff">查询
          </el-button>

        </div>

      </div>

    </div>

    <div v-if="needHiden"
         style="display: flex;justify-content:center;margin-top:80px;font-size:15px;color:#999;height:300px"> 请输入17位
      设备CID，并点击《查询》按钮进行初始化！
    </div>


    <div v-if="!needHiden"
         style="display: flex;flex-direction:row;flex-wrap: wrap;justify-content:center;margin:5px;margin-top:5px;font-size:16px;color:#111">

      <el-divider content-position="center">设备基础信息</el-divider>


      <div style="height:80px;width:100%;background-color:#f8f8f8;">

        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:10px;width:100%;height:60px" class="container_right">

            <div style="width:70%;display:flex">


              <div style="display: flex;margin:10px;">
                <div style="flex: 1;width:230px;margin-left:5px;margin-right:10px">CID：{{ deviceInfo.cid }}
                </div>
              </div>


              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:240px;margin:5px;margin-right:5px">产品类型：</div>
                    <el-select @change="selectChangeProduct" size = "medium" placeholder="请选择产品类型" v-model="product" >

                      <el-option
                        v-for="item in ccproductList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>

<!--                 <el-input
                    style="width:200px;"
                    placeholder="模型类型"
                    v-model="deviceInfo.devicemodel"
                    type="text"
                    clearable>
                </el-input> -->
              </div>
           

              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:100px;margin:5px;margin-right:5px">MAC/IMEI：</div>
                <el-input
                    style="width:250px;"
                    placeholder="输入设备的MAC或IMEI"
                    v-model="deviceInfo.mac"
                    type="text"
                    clearable>
                </el-input>
              </div>










            </div>

            <div style="width:15%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B">
              <el-button @click="getMQTTInfo" size="mini" style="width:70%;background-color:#970B0B;color:#fff">
                显示MQTT参数
              </el-button>
            </div>

          </div>
        </div>
      </div>

      <div style="height:80px;width:100%;background-color:#f8f8f8;">

        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:5px;width:100%;height:60px" class="container_right">

            <div style="width:70%;display:flex">
   
            <div style="display: flex;margin-left:10px;margin-top:10px;">
 
                <div style="flex: 1;width:50px;margin:5px;margin-right:0px">项目：</div>
                  <el-select @change="selectChangeProject" size = "medium" placeholder="请选择项目" v-model="deviceInfo.project" >

                    <el-option
                      v-for="item in ccprojectList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>

              </div>



              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:5px">设备昵称：</div>
                <el-input
                    style="width:250px;"
                    placeholder="输入设备昵称"
                    v-model="deviceInfo.devicename"
                    type="text"
                    clearable>
                </el-input>
              </div>


           

            </div>

            <div style="width:15%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B">
              <el-button @click="handlEditDeviceInfo" size="mini" style="width:70%;background-color:#970B0B;color:#fff">
                保存修改
              </el-button>
            </div>

          </div>
        </div>


      </div>




      <el-divider content-position="center">状态显示(点击状态进行编辑)</el-divider>


      <div v-for="item in diyStatusListArr" :key="item.sensor" v-on:click="editStatus(item)"
           style="font-size:20px;color:#111;margin:15px;">{{ item.sensor }}: {{ item.value }}{{ item.unit }}
      </div>

           <el-button @click="addStatus" size="mini"
                     style="width:120px;height: 40px; color:#FFF;font-size:15px;background-color:#970B0B;margin:20px;margin-top:40px;">
            新增状态显示
          </el-button>



      <el-divider content-position="center">功能按钮(点击按钮进行编辑)</el-divider>


      <div style="margin-top:5px;padding:5px">

        <div style="display: flex;justify-content:space-around;margin:5px;flex-wrap: wrap;">

        <div  v-for="item in diyFuncListArr" :key="item.sensor" v-on:click="editFunc(item)" style="display:flex;flex-direction:column">
              <img   :src='item.current.icon' alt="Image" style="margin: 10px;width: 80px; height: 80px;" mode="aspectFit">
               <div style="margin: 5px;width: 80px; height: 20px;text-align: center;"> {{item.sensor}}</div>
        </div>
         

           <el-button @click="addFunc" size="mini"
                     style="width:120px;height: 40px; color:#FFF;font-size:15px;background-color:#970B0B;margin:20px;margin-top:40px;">
            新增控制按钮
          </el-button>

        </div>
        
      </div>

    </div>


    <el-dialog
        :visible.sync="centerDialogVisibleFunc"
        width="80%"
        center
        :destroy-on-close=true
        :show-close=false
        :close-on-click-modal=false
        :close-on-press-escape=false
    >
      <div>
        <div style="height:40px;width:100%;background-color:#fff;">
          <div style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">

            <div style="width:40%;display:flex">
              <div style="width:4px;background-color:#970B0B;height:40px"></div>
              <div style="margin:5px;color:#970B0B;">新增控制按钮</div>
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>

        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">


            <div style="width:70%;display:flex">

              <div style="display: flex;margin:10px;margin-top:15px;">
                <div style="flex: 1;width:200px;margin-left:5px;margin-right:15px">CID：{{ cid }}
                </div>
              </div>


              <div style="display: flex;margin-left:30px;margin-top:10px;">
                <div style="flex: 1;width:200px;margin:5px;margin-right:10px">功能：</div>
                <el-select @change="selectChangeFunc" size="medium" placeholder="请选择控制按钮模板" v-model="cselectFunc">

                  <el-option
                      v-for="item in configSensorFuncList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>


            </div>


            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>
        <div style="color:#970B0B;font-size:13px;margin:20px 0px 0px 20px">提醒：新增按钮后，请可自行修改指令和参数！</div>

      </div>

      <span slot="footer" class="dialog-footer ">
    <el-button style="width:120px" @click="cancelBtnFunc">取 消</el-button>
    <el-button style="background-color:#970B0B;color:#fff;width:120px" @click="addGroupFunc">确 定</el-button>
  </span>
    </el-dialog>




    <el-dialog
        :visible.sync="centerDialogVisibleEditFunc"
        width="80%"
        center
        :destroy-on-close=true
        :show-close=false
        :close-on-click-modal=false
        :close-on-press-escape=false
    >
      <div>
        <div style="height:40px;width:100%;background-color:#fff;">
          <div style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">

            <div style="width:40%;display:flex">
              <div style="width:4px;background-color:#970B0B;height:40px"></div>
              <div style="margin:5px;color:#970B0B;">功能按钮信息</div>
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>

        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">

            <div style="width:70%;display:flex">


              <div style="display: flex;margin:10px;">
                <div style="flex: 1;width:100px;margin-left:5px;margin-right:10px">sensorid：{{ groupInfoFunc.sensorid }}
                </div>
              </div>


              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:5px">按钮名称：</div>
                <el-input
                    style="width:200px;"
                    placeholder="输入控制按钮名称"
                    v-model="groupInfoFunc.sensor"
                    type="text"
                    clearable>
                </el-input>
              </div>
              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:5px">按钮指令：</div>
                <el-input
                    style="width:200px;"
                    placeholder="输入控制按钮指令"
                    v-model="groupInfoFunc.sensorname"
                    type="text"
                    clearable>
                </el-input>
              </div>


            </div>

            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>


        <div style="height:200px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">

            <div style="width:70%;display:flex">


              <div style="display: flex;margin-left:20px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:10px">指令参数：</div>
                <el-input
                    style="width:800px;"
                    placeholder="请输入指令参数,JSON格式"
                    v-model="groupInfoFunc.data"
                    type="textarea"
                    :rows="8"
                    clearable>
                </el-input>
              </div>


            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>

        </div>

        <div style="color:#970B0B;font-size:13px;margin:20px 0px 0px 20px">
          提醒：所有信息为必填，指令参数JSON格式！可以使用在线工具编辑JSON：https://www.json.cn
        </div>


      </div>

          <span slot="footer" class="dialog-footer ">
        <el-button style="width:120px" @click="centerDialogVisibleEditFunc = false">取 消</el-button>
        <el-button style="background-color:#E7383B;color:#fff; width:120px" @click="deleteSensorFunc">删 除</el-button>
        <el-button style="background-color:#970B0B;color:#fff;width:120px" @click="updateGroupFunc">确 定</el-button>
      </span>
    </el-dialog>






    <el-dialog
        :visible.sync="centerDialogVisibleEditStatus"
        width="80%"
        center
        :destroy-on-close=true
        :show-close=false
        :close-on-click-modal=false
        :close-on-press-escape=false
    >
      <div>
        <div style="height:40px;width:100%;background-color:#fff;">
          <div style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">

            <div style="width:40%;display:flex">
              <div style="width:4px;background-color:#970B0B;height:40px"></div>
              <div style="margin:5px;color:#970B0B;">状态显示信息</div>
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>

        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">

            <div style="width:70%;display:flex">


              <div v-if="isGroupEditStatus" style="display: flex;margin:10px;">
                <div style="flex: 1;width:100px;margin-left:5px;margin-right:10px">sensorid：{{ groupInfoStatus.sensorid }}
                </div>
              </div>


              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:5px">状态名称：</div>
                <el-input
                    style="width:200px;"
                    placeholder="输入状态名称"
                    v-model="groupInfoStatus.sensor"
                    type="text"
                    clearable>
                </el-input>
              </div>
              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:5px">状态指令：</div>
                <el-input
                    style="width:200px;"
                    placeholder="输入状态指令"
                    v-model="groupInfoStatus.sensorname"
                    type="text"
                    clearable>
                </el-input>
              </div>


            </div>

            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>



        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">

            <div style="width:70%;display:flex">



              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:60px;margin:5px;margin-right:5px">默认值：</div>
                <el-input
                    style="width:200px;"
                    placeholder="请输入默认值"
                    v-model="groupInfoStatus.defaultvalue"
                    type="text"
                    clearable>
                </el-input>
              </div>


              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:5px">单位：</div>
                <el-input
                    style="width:200px;"
                    placeholder="请输入状态显示单位"
                    v-model="groupInfoStatus.unit"
                    type="text"
                    clearable>
                </el-input>
              </div>
              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:5px">是否翻译：</div>
                <el-input
                    style="width:200px;"
                    placeholder="请选择是否翻译"
                    v-model="groupInfoStatus.istranslate"
                    type="text"
                    clearable>
                </el-input>
              </div>


            </div>

            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>



        <div style="height:200px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">

            <div style="width:70%;display:flex">


              <div style="display: flex;margin-left:20px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:10px">指令参数：</div>
                <el-input
                    style="width:800px;"
                    placeholder="请输入指令参数,JSON格式"
                    v-model="groupInfoStatus.translatedata"
                    type="textarea"
                    :rows="8"
                    clearable>
                </el-input>
              </div>


            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>

        </div>

        <div style="color:#970B0B;font-size:13px;margin:20px 0px 0px 20px">
          提醒：所有信息为必填，指令参数JSON格式！可以使用在线工具编辑JSON：https://www.json.cn
        </div>


      </div>

          <span slot="footer" class="dialog-footer ">
        <el-button style="width:120px" @click="centerDialogVisibleEditStatus = false">取 消</el-button>
        <el-button style="background-color:#E7383B;color:#fff; width:120px" @click="deleteSensorStatus">删 除</el-button>
        <el-button style="background-color:#970B0B;color:#fff;width:120px" @click="updateGroupStatus">确 定</el-button>
      </span>
    </el-dialog>



    <el-dialog
        :visible.sync="centerDialogVisibleStatus"
        width="80%"
        center
        :destroy-on-close=true
        :show-close=false
        :close-on-click-modal=false
        :close-on-press-escape=false
    >
      <div>
        <div style="height:40px;width:100%;background-color:#fff;">
          <div style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">

            <div style="width:40%;display:flex">
              <div style="width:4px;background-color:#970B0B;height:40px"></div>
              <div style="margin:5px;color:#970B0B;">新增状态显示</div>
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>

        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">


            <div style="width:70%;display:flex">

              <div style="display: flex;margin:10px;margin-top:15px;">
                <div style="flex: 1;width:200px;margin-left:5px;margin-right:15px">CID：{{ cid }}
                </div>
              </div>


              <div style="display: flex;margin-left:30px;margin-top:10px;">
                <div style="flex: 1;width:200px;margin:5px;margin-right:10px">功能：</div>
                <el-select @change="selectChangeStatus" size="medium" placeholder="请选择状态显示模板" v-model="cselectStatus">

                  <el-option
                      v-for="item in configSensorStatusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>


            </div>


            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>
        <div style="color:#970B0B;font-size:13px;margin:20px 0px 0px 20px">提醒：新增按钮后，请可自行修改指令和参数！</div>

      </div>

      <span slot="footer" class="dialog-footer ">
    <el-button style="width:120px" @click="cancelBtnStatus">取 消</el-button>
    <el-button style="background-color:#970B0B;color:#fff;width:120px" @click="addGroupStatus">确 定</el-button>
  </span>
    </el-dialog>




    <el-dialog
        :visible.sync="MQTTcenterDialogVisibleStatus"
        width="80%"
        center
        :destroy-on-close=true
        :show-close=false
        :close-on-click-modal=false
        :close-on-press-escape=false
    >
      <div>
        <div style="height:40px;width:100%;background-color:#fff;">
          <div style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">

            <div style="width:40%;display:flex">
              <div style="width:4px;background-color:#970B0B;height:40px"></div>
              <div style="margin:5px;color:#970B0B;">MQTT对接信息（请复制后妥善保管）</div>
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>



          <div style="height:200px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">

            <div style="width:70%;display:flex">


              <div style="display: flex;margin-left:20px;margin-top:10px;">
                <el-input
                    style="width:800px;"
                    placeholder="MQTT对接信息,JSON格式"
                    v-model="MQTTInfo"
                    type="textarea"
                    :rows="8"
                    clearable>
                </el-input>
              </div>


            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>

        </div>

        <div style="color:#970B0B;font-size:13px;margin:20px 0px 0px 20px">
          提醒：请妥善保管MQTT对接信息，请勿发送给任何人！请使用在线工具查看JSON：<a @click="getNewsDetail">https://www.json.cn</a>
        </div>

      </div>

      <span slot="footer" class="dialog-footer ">
    <el-button style="width:120px" @click="cancelMQTTFunc">关 闭</el-button>
  </span>
    </el-dialog>











  </div>
</el-aside>
</template>

<script>

import TMApipath from 'TMApipath'
import TMStore from 'TMStore'
import {formatTime, isJsonType} from 'TMUtils'
// import TMConfig from 'TMConfig'


var hmacsha256 = require('crypto-js/hmac-sha256');









export default {
  methods: {

    //第二种
    getNewsDetail() {
      var url="https://www.json.cn"
      window.open(url, "_blank");
    },


    deleteSensorFunc() {

      var _this = this

      var params = {
        sensorid: _this.groupInfoFunc.sensorid
      }


      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_DELETESENSORFUNC, reqdata);

      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          _this.centerDialogVisibleEditFunc = false;

          // vuex记录
          _this.getSensorFunc(_this.pageInfo.val, _this.pageInfo.size);

        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });

    },
    deleteSensorStatus() {

      var _this = this

      var params = {
        sensorid: _this.groupInfoStatus.sensorid
      }


      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_DELETESENSORSTATUS, reqdata);

      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          _this.centerDialogVisibleEditStatus = false;

          // vuex记录
          _this.getSensorStatus(_this.pageInfo.val, _this.pageInfo.size);

        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });

    },

    selectChangeFunc(val) {//匹配对应的按钮
      var _this = this

      console.log('selectChangeFunc val',val)

      for (var items in _this.configSensorFuncList) {
        var item = _this.configSensorFuncList[items]

        if (item.sensorname === val) {

          _this.groupInfoFunc = item;

          break;
        }

      }
    },
    selectChangeStatus(val) {//匹配对应的按钮
      var _this = this

      console.log('selectChangeStatus val',val)

      for (var items in _this.configSensorStatusList) {
        var item = _this.configSensorStatusList[items]

        if (item.sensorname === val) {

          _this.groupInfoStatus = item;

          break;
        }

      }
    },
    handleEditFunc(item) {
      console.log(item)

      this.centerDialogVisibleFunc = true;
      this.isGroupEditFunc = false;
      this.cselectFunc = '';

      this.groupInfoFunc = {
        cid: '',
        sensorid:'',
        project: '',
        sensor: '',
        sensorname: '',
        data: '',
        cselectFunc: ''
      }

    },
    handleEditStatus(item) {
      console.log(item)

      this.centerDialogVisibleStatus = true;
      this.isGroupEditStatus = false;
      this.cselectStatus = '';

      this.groupInfoStatus = {
        cid: '',
        sensorid:'',
        project: '',
        sensor: '',
        sensorname: '',
        defaultvalue: '--',
        unit: '',
        istranslate: 0,
        translatedata: '[]',

        cselectStatus: ''
      }

    },

    cancelBtnFunc() {
      var _this = this;
      _this.centerDialogVisibleFunc = false;
      _this.groupInfoFunc = {}

    },
    cancelBtnStatus() {
      var _this = this;
      _this.centerDialogVisibleStatus = false;
      _this.groupInfoStatus = {}

    },
    cancelMQTTFunc() {
      var _this = this;
      _this.MQTTcenterDialogVisibleStatus = false;
      _this.MQTTInfo = {}

    },
    
    addStatus(item) {
      console.log('addStatus', item)
      this.isGroupEditStatus = false;

      this.handleEditStatus(item)

    },
    addFunc(item) {
      console.log('addFunc', item)
      this.handleEditFunc(item)

    },
    editStatus(val) {
      console.log('editStatus', val)
        var _this = this

      _this.centerDialogVisibleEditStatus = true;
      _this.isGroupEditStatus = true;


      for (var items in _this.diyStatusListArrAll) {
        var item = _this.diyStatusListArrAll[items]

        if (item.sensorid == val.sensorid) {
         
          _this.groupInfoStatus = item;
          console.log('editStatus item.sensorid',item.sensorid)
          break;
        }

      }

    },
    editFunc(val) {

      var _this = this

      _this.centerDialogVisibleEditFunc = true;


      for (var items in _this.diyFuncListArrAll) {
        var item = _this.diyFuncListArrAll[items]

        if (item.sensorid == val.sensorid) {
         
          _this.groupInfoFunc = item;
          console.log('editFunc item.sensorid',item.sensorid)
          break;
        }

      }


    },


    updateGroupFunc() {

      var _this = this


      if (!_this.groupInfoFunc.sensor || !_this.groupInfoFunc.sensorname || !_this.groupInfoFunc.data) {
        this.$message.error("请填写相关必填信息");
        return
      }


      if (_this.groupInfoFunc.data === "" || !isJsonType(_this.groupInfoFunc.data)) {
        this.$message.error("result为空或不是json");

        return
      }


      var params = {
        sensorid: _this.groupInfoFunc.sensorid,
        sensor: _this.groupInfoFunc.sensor,
        sensorname: _this.groupInfoFunc.sensorname,
        data: JSON.parse(_this.groupInfoFunc.data)
      }


  if (params.sensor != params.data.sensor || params.sensorname != params.data.sensorname) {
                this.$message.error("按钮名称或按钮指令不配置,请检查！");
                return;
          }


      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_EDITSENSORFUNC, reqdata);

      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          _this.centerDialogVisibleEditFunc = false;

          // vuex记录
          _this.getSensorFunc(_this.pageInfo.val, _this.pageInfo.size);

        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });

    },
    updateGroupStatus() {

      var _this = this


      if (!_this.groupInfoStatus.sensor || !_this.groupInfoStatus.sensorname || !_this.groupInfoStatus.unit|| !_this.groupInfoStatus.value) {

        this.$message.error("请填写相关必填信息");
        return
      }


      if (_this.groupInfoStatus.translatedata === "" || !isJsonType(_this.groupInfoStatus.translatedata)) {
        this.$message.error("translatedata为空或不是json");

        return
      }


      var params = {
        sensorid: _this.groupInfoStatus.sensorid,
        sensor: _this.groupInfoStatus.sensor,
        sensorname: _this.groupInfoStatus.sensorname,
        value:_this.groupInfoStatus.defaultvalue,
        unit:_this.groupInfoStatus.unit,
        istranslate: 0,// _this.groupInfoStatus.istranslate,//默认 0 ,为1的场景未实现

        translatedata: JSON.parse(_this.groupInfoStatus.translatedata)
      }

      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_EDITSENSORSTATUS, reqdata);

      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          _this.centerDialogVisibleEditStatus = false;

          // vuex记录
          _this.getSensorStatus(_this.pageInfo.val, _this.pageInfo.size);

        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });

    },
    addGroupFunc() {

      var _this = this;

      if (!_this.groupInfoFunc.sensorname) {
        this.$message.error("请选择功能");
        return
      }


      if (_this.isGroupEditFunc) {
        _this.updateGroupFunc();
        return;
      }

      var params = {
        cid: _this.cid,
        project: _this.groupInfoFunc.project,
        sensor: _this.groupInfoFunc.sensor,
        sensorname: _this.groupInfoFunc.sensorname,
        data: JSON.parse(_this.groupInfoFunc.data)
      }
      console.log('params', params);

      // return;

      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_ADDSENSORFUNC, reqdata);

      console.log(urls)

      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          _this.centerDialogVisibleFunc = false;
          // vuex记录
          _this.getSensorFunc(_this.pageInfo.val, _this.pageInfo.size);
        } else {
          _this.$message.error(response.msg);
        }

      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        _this.$message.error("系统异常");
        console.log(response)
      });


    },
    addGroupStatus() {

      var _this = this;

      if (!_this.groupInfoStatus.sensorname) {
        this.$message.error("请选择功能");
        return
      }


      if (_this.isGroupEditStatus) {
        _this.updateGroupStatus();
        return;
      }


     // if (!_this.groupInfoStatus.sensor || !_this.groupInfoStatus.sensorname || !_this.groupInfoStatus.translatedata) {
     //    this.$message.error("请填写相关必填信息");
     //    return
     //  }


     //  if (_this.groupInfoStatus.translatedata === "" || !isJsonType(_this.groupInfoStatus.translatedata)) {
     //    this.$message.error("result为空或不是json");

     //    return
     //  }


      var params = {
        cid:_this.cid,
        sensorid: _this.groupInfoStatus.sensorid,
        sensor: _this.groupInfoStatus.sensor,
        sensorname: _this.groupInfoStatus.sensorname,
        value:_this.groupInfoStatus.defaultvalue,
        unit:_this.groupInfoStatus.unit,
        istranslate:_this.groupInfoStatus.istranslate,

        translatedata: JSON.parse(_this.groupInfoStatus.translatedata)
      }

      console.log('params', params);

      // return;

      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_ADDSENSORSTATUS, reqdata);

      console.log(urls)

      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          _this.centerDialogVisibleStatus = false;
          // vuex记录
          _this.getSensorStatus(_this.pageInfo.val, _this.pageInfo.size);
        } else {
          _this.$message.error(response.msg);
        }

      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        _this.$message.error("系统异常");
        console.log(response)
      });


    },


    getSensorStatus() {

      var _this = this

      var params = {
        cid: _this.cid
      }

      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_GETSENSORSTATUS, reqdata);


      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});


      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          // vuex记录

          _this.diyStatusListArr = []
          _this.diyStatusListArrAll = []

          var nlist = []
          var diylist = []
          // var item = response.data.result

          // var datas = JSON.parse( item.data)
          var datas = response.data.result


          for (var items in datas) {

            var icc = datas[items]


            icc = Object.assign(icc, {defaultvalue : icc.value})

            nlist.push(icc)
            diylist.push(icc)

            // diylist.push({
            //   value: icc.value,
            //   sensor: icc.sensor,
            //   unit: icc.unit
            // })

          }

          _this.diyStatusListArr = nlist;
          _this.diyStatusListArrAll = response.data.result;
              // _this.showDiyStatusArr = diylist


        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });

    },
    getSensorFunc() {

      var _this = this

      var params = {
        cid: _this.cid
      }

      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_GETSENSORFUNC, reqdata);


      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});


      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          // vuex记录


          var nlist = []
          for (var items in response.data.result) {
            var item = response.data.result[items]

            var datas = JSON.parse(item.data)


            var cutFeed = {
              sensorid: item.sensorid,
              cid: _this.cid,
              sensor: datas.sensor,
              sensorname: datas.sensorname,
              cmd: datas.cmd,
              status: datas.status,
              current: datas.status[1]
            }

            nlist.push(cutFeed)

          }
          _this.diyFuncListArr = nlist;

          _this.diyFuncListArrAll = response.data.result;

// console.log(' _this.diyFuncListArr:', _this.diyFuncListArr)
// console.log(' _this.diyFuncListArrAll:', _this.diyFuncListArrAll)


        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });

    },

    getConfigSensorStatusListByPage(pageIndex, pageSize) {

      var _this = this

      var reqdata = {pageIndex: pageIndex, pageSize: pageSize}
      var {
        
        urls
      } = _this.getresult(TMApipath.CONFIGMANAGE, TMApipath.URL_API_GETCONFIGSENSORSTATUSLISTBYPAGE, reqdata);


      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});


      _this.axios.get(urls).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          // vuex记录

          _this.configSensorStatusList = [];


          for (var items in response.data.list) {
            var item = response.data.list[items]

            var cutFeed = {
              cid: _this.cid,

              label: item.sensor,
              value: item.sensorname,
              id: item.id,
              project: item.project,
              sensor: item.sensor,
              sensorname: item.sensorname,

              defaultvalue: item.value,
              unit: item.unit,
              istranslate: item.istranslate ,
              translatedata: item.translatedata,
              createTime: formatTime(item.createDate),
              updateTime: item.updateDate!='' ? formatTime(item.updateDate) : '--'

            }

            _this.configSensorStatusList.push(cutFeed);
          }


        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });


    },
    getConfigSensorFuncListByPage(pageIndex, pageSize) {

      var _this = this

      var reqdata = {pageIndex: pageIndex, pageSize: pageSize}
      var {
        
        urls
      } = _this.getresult(TMApipath.CONFIGMANAGE, TMApipath.URL_API_GETCONFIGSENSORFUNCLISTBYPAGE, reqdata);


      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});


      _this.axios.get(urls).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          // vuex记录

          _this.configSensorFuncList = [];

          // _this.pageInfo.total = response.data.total

          for (var items in response.data.list) {
            var item = response.data.list[items]

            var cutFeed = {
              cid: _this.cid,
              sensorid: item.sensorid,

              label: item.sensor,
              value: item.sensorname,
              id: item.id,
              project: item.project,
              sensor: item.sensor,
              sensorname: item.sensorname,
              data: item.data,
              createTime: formatTime(item.createDate),
              updateTime: item.updateTime ? formatTime(item.updateDate) : '--'

            }

            _this.configSensorFuncList.push(cutFeed);
          }


        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });


    },
    //----------其他-------
    getOneDevice() {

      var _this = this

      var reqdata = {cid: _this.cid}
      var { urls} = _this.getresult(TMApipath.DEVICE, TMApipath.URL_API_GETONEDEVICE, reqdata);


      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});


      _this.axios.get(urls, reqdata).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          // vuex记录


          if (response.data.result.length > 0) {
            _this.deviceInfo = response.data.result[0];
            _this.deviceInfo.cid = response.data.cid;
            _this.product = response.data.result[0].devicemodel;
            _this.needHiden = false;
            this.$message.success("查询成功！");


          } else {
            this.$message.error("查询失败，请检查CID是否正确！");
          }


        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });

    },

    editDeviceInfo() {

      var _this = this


      var params = {
        cid: _this.cid,
        project: _this.deviceInfo.project,
        projectkey: _this.deviceInfo.projectkey,
        mac: _this.deviceInfo.mac,
        devicemodel: _this.product,
        devicename: _this.deviceInfo.devicename.trim(),

      }
      
      if (params.devicename.length >25) {
          this.$message.error("设备昵称太长，最大长度25");
          return

      } 


      var reqdata = {}
      var { urls} = _this.getresult(TMApipath.DEVICE, TMApipath.URL_API_EDITDEVICEINFO, reqdata);

      let loadingInstance = _this.$loading({fullscreen: true, text: "Loading"});

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        if (response.status) {
          _this.centerDialogVisibleEditFunc = false;

          // vuex记录
          _this.getOneDevice();

        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => {
          loadingInstance.close();
        });
        console.log(response)
      });

    },

    RightAddClick() {
      var _this = this

      if (!_this.cid || (_this.cid.length != 17)) {
        this.$message.error("请输入17位 CID");
        return
      }


      this.getSensorFunc()

      this.getSensorStatus()

      this.getOneDevice()


      this.getConfigSensorFuncListByPage(1, 100)
      this.getConfigSensorStatusListByPage(1,100)


    },
    // 获取当前设备的MQTT信息，计算后获得
    getMQTTInfo(){
      var _this = this;

console.log('_this.deviceInfo,',_this.deviceInfo)

      var productKey = _this.deviceInfo.productKey
      var deviceName = _this.deviceInfo.cid
      var deviceSecret = _this.deviceInfo.deviceSecret
      var briefId = _this.deviceInfo.clientId


      var timestamp = ''+new Date().getTime();
      var clientId = briefId + '|securemode=' + 2 + ',signmethod=hmacsha256' + ',timestamp=' + timestamp + '|'
      var username = deviceName + '&' + productKey
      var plainText = 'clientId' + briefId + 'deviceName' + deviceName  + 'productKey' + productKey  +  'timestamp' + timestamp


      var passwd = hmacsha256(plainText, deviceSecret).toString();


      // console.log('plainText:',plainText)
      // console.log('deviceSecret:',deviceSecret)


      console.log('clientId:',clientId)
      console.log('username:',username)
      console.log('passwd:',passwd)

      var ccstr = {
        cid:deviceName,
        mqttClientId:clientId,
        username:username,
        passwd:passwd,
        subtopic:"server/home/"+deviceName,
        pubtopic:"client/home/"+deviceName,
        mqttHostUrl:'mqtt.fairycloud.xyz',
        port: 1883

      }

      _this.MQTTInfo = JSON.stringify(ccstr)

      _this.MQTTcenterDialogVisibleStatus = true



    },
    handlEditDeviceInfo() {//待实现
      var _this = this;


      if (!_this.deviceInfo.projectkey) {
        this.$message.error("请填写相关必填信息项目、数据类型");
        return
      }


      _this.$confirm('此操作将更改设备关键数据, 是否保存?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {

        _this.editDeviceInfo()


      }).catch(() => {

      });

    },
      selectChangeProject(val){//匹配对应的VISON
        var _this = this

          for(var items in _this.ccprojectList){
                var item = _this.ccprojectList[items]


               if (item.value === val) {
                  _this.deviceInfo.projectkey = item.value;
                  _this.deviceInfo.project = item.label;

                  break;
               }

          }
      },
      selectChangeProduct(val){//匹配对应的VISON
        var _this = this

          for(var items in _this.ccproductList){
                var item = _this.ccproductList[items]


               if (item.value === val) {
                  _this.deviceInfo.productkey = item.value;
                  _this.deviceInfo.product = item.label;

                  break;
               }

          }
      },
      getConfigProductListByPage(pageIndex, pageSize){

          var _this = this 

          var reqdata = {pageIndex:pageIndex,pageSize:pageSize}
          var { urls} = _this.getresult(TMApipath.CONFIGMANAGE,TMApipath.URL_API_GETCONFIGPRODUCTLISTBYPAGE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.ccproductList =[];

                // _this.pageInfo.total = response.data.total

              for(var items in response.data.list){
                var item = response.data.list[items]

                var cutFeed ={
                  id: item.id,
                  project: item.product,
                  projectkey: item.productKey,
                  devicemodel:item.devicemodel,
                  grouptype: item.grouptype,
                  value:item.devicemodel,
                  label:item.devicemodel,

                }

                _this.ccproductList.push(cutFeed);
              }




            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });


      },
      getConfigProjectListByPage(pageIndex, pageSize){

          var _this = this 

          var reqdata = {pageIndex:pageIndex,pageSize:pageSize}
          var { urls} = _this.getresult(TMApipath.CONFIGMANAGE,TMApipath.URL_API_GETCONFIGPROJECTLISTBYPAGE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.ccprojectList =[];

                // _this.pageInfo.total = response.data.total

              for(var items in response.data.list){
                var item = response.data.list[items]

                var cutFeed ={
                  id: item.id,
                  project: item.project,
                  projectkey: item.projectkey,

                  value:item.projectkey,
                  label:item.project,

                }

                _this.ccprojectList.push(cutFeed);
              }




            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });


      },




  },
  beforeDestroy() {
    // var _this = this
    
  },
  mounted() {

    var _this = this

    _this.cid = this.$route.query.cid

    _this.token = TMStore.state.account.token
    _this.aid = TMStore.state.account.aid
       _this.getConfigProjectListByPage(1,100);

    if (_this.cid == '' || typeof (_this.cid) == "undefined") {
      console.log('cid为空')
      _this.cid = ''


    } else {
      console.log('cid', _this.cid)

      _this.getSensorFunc()
      _this.getSensorStatus()
      _this.getOneDevice()
      _this.getConfigSensorFuncListByPage(1, 100)
      _this.getConfigSensorStatusListByPage(1, 100)
      _this.getConfigProductListByPage(1,100);


    }


  },
  data() {
    return {
      needHiden: true,
      cselectFunc: '',
      cselectStatus:'',

      centerDialogVisibleFunc: false,
      centerDialogVisibleEditFunc: false,
      isGroupEditFunc: false,

      centerDialogVisibleStatus: false,
      MQTTcenterDialogVisibleStatus: false,
      MQTTInfo: '',
      centerDialogVisibleEditStatus: false,
      isGroupEditStatus: false,

      groupInfoFunc: {
       project: 'home',
        sensor: '',
        sensorname: '',
        data: '',
        cselectFunc: ''
      },

      groupInfoStatus:{
       project: 'home',
        sensorid: '',
        sensor: '',
        sensorname: '',
        defaultvalue: '--',
        unit:'',
        istranslate:'',
        translatedata:'[]',
        cselectStatus: ''
      },

      pageInfo: {
        val: 1,
        size: 100,
        total: 0
      },

      deviceshowdata: {reporttime: ''},
      deviceInfo: "",
      diyStatusListArr: [],
      diyStatusListArrAll: [],
      configSensorStatusList: [],


      message: '',
      controllLoading: false,
      controlldid: '',
      fotaloading: false,
      loadingInstance: '',
      // showDiyStatusArr: [],
      aid: '',
      token: '',
      cid: '',
      updateDate: '',
      connectStatus: '已断开',
      connetIsOpen: false,
      socket: '',
      heart: '',
      heartBeatFailCount: 0,
      heartBeatTimeOut: null,
      diyFuncListArr: [],
      diyFuncListArrAll: [],
      configSensorFuncList: [],

      projectkey:'',
      project:'',
      ccprojectList:[],
      ccproductList:[],
      product:'',

    }
  }
}


</script>


<style lang="stylus" scoped>
.groups
  overflow: hidden

.rightButton
  width: 30px

.container_right
  margin: 5px
  display: flex
  justify-content: center
  align-items: flex-start

.el-dialog_header
  padding: 0px
</style>